function syncWikiTocVariant() {
  const tocTitle = document.getElementById("toc-title");

  if (!tocTitle) {
    return;
  }

  if (window.location.pathname.includes("/wiki/developer")) {
    tocTitle.classList.add("toc--developer");
    return;
  }

  tocTitle.classList.remove("toc--developer");
}

function syncWikiLastPageSize() {
  const tocSection = document.getElementById("section-toc");

  if (!tocSection) {
    return null;
  }

  const lastPageWidth = Number(tocSection.dataset.lastPageWidth || "");
  tocSection.dataset.lastPageWidth = String(window.innerWidth);

  return Number.isFinite(lastPageWidth) ? lastPageWidth : null;
}

function syncStickyTocDefaultOpen() {
  const tocSection = document.getElementById("section-toc");

  if (!tocSection) {
    return;
  }

  const firstDetails = tocSection.querySelector("#toc > details:first-child");

  if (!firstDetails) {
    return;
  }

  if (tocSection.dataset.stickyTocUserInteracted === "true") {
    return;
  }

  const isSticky = window.getComputedStyle(tocSection).position === "sticky";

  if (isSticky) {
    if (!firstDetails.hasAttribute("open")) {
      firstDetails.setAttribute("open", "");
    }
    return;
  }

  if (firstDetails.hasAttribute("open")) {
    firstDetails.removeAttribute("open");
  }
}

function trackStickyTocInteraction() {
  const tocSection = document.getElementById("section-toc");

  if (!tocSection || tocSection.dataset.stickyTocInteractionBound === "true") {
    return;
  }

  const summaryElements = tocSection.querySelectorAll("#toc details > summary");

  summaryElements.forEach((summaryElement) => {
    summaryElement.addEventListener("click", () => {
      tocSection.dataset.stickyTocUserInteracted = "true";
    });
  });

  tocSection.dataset.stickyTocInteractionBound = "true";
}

window.addEventListener("DOMContentLoaded", () => {
  syncWikiTocVariant();
  trackStickyTocInteraction();
  syncWikiLastPageSize();
  syncStickyTocDefaultOpen();
});

window.addEventListener("resize", () => {
  syncWikiLastPageSize();
  syncStickyTocDefaultOpen();
});
